import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

// Every path the router does not know lands here (#118). Apache still answers 200 (the SPA fallback), so the page
// tells search engines not to index it; no SEOHead, so no canonical or og:url names a path that does not exist.
export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="not-found-page">
      <Helmet>
        <title>Page Not Found | NextDayRefund.com</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Navbar />
      <div className="section-container py-16 flex items-center justify-center">
        <div className="w-full max-w-md bg-white border border-slate-200 rounded-xl p-8 shadow-sm text-center">
          <h1 className="text-xl font-black text-[#003366] mb-2">Page not found</h1>
          <p className="text-[#64748B] text-sm mb-6">We couldn't find the page you were looking for.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="btn-action inline-block">Go to the homepage</Link>
            <Link to="/find-provider" className="btn-action inline-block">Find a Provider</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
